import React, { Component } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import MenuCategory from './MenuCategory';
import i18next from 'i18next';

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "white",
    display: 'flex',
    flexDirection: i18next.dir() === 'rtl' ? 'row-reverse' : 'row',
    flex: 1,
    overflowX: 'auto',
    height: '100%',
    minHeight: 60,
});

class PrimaryCategories extends Component {
    render() {
        return (
            <Droppable
                direction="horizontal"
                type={`categories-${this.props.parantId || ''}`}
                // type="category"
                droppableId={this.props.parantId ? `${this.props.parantId}-categories` : 'primary-categories'}
            >
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {this.props.categories.map((category, index) => (
                            <MenuCategory
                                key={category.id}
                                category={category}
                                handleSubcategoryClick={this.props.handleSubcategoryClick}
                                branchIdForOverride={this.props.branchIdForOverride}
                                index={index}
                                
                                
                            />
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        );
    }
}

PrimaryCategories.propTypes = {
    categories: PropTypes.array
};

export default PrimaryCategories;
